module.exports = __webpack_public_path__ + "img/16.303eb36b.png";